import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function Variants({...other}) {
  return (
    <Stack key={other.key} spacing={1}>
      <Skeleton key={other.key} sx={{ display: "flex", alignItems: "center", gap: 1 }} variant="rounded" width={'100%'} height={60} />
    </Stack>
  );
}
